export default __webpack_public_path__ + "static/media/img-0345-ukraine-half-face.c957e3b2.png";